import i18n from 'i18next';

import useAdhocLetters from '../hooks/useAdhocLetters';

const transformLetters = (letters) =>
  letters.map((letter) => ({
    label: letter.name,
    value: letter.id,
  }));

export default ({ hasCreateLetterAccess = false }) => {
  const { letters } = useAdhocLetters();
  return {
    ...(hasCreateLetterAccess && {
      radioOptions: {
        type: 'Radio',
        options: [
          { label: i18n.t('template'), value: 'template' },
          { label: i18n.t('custom'), value: 'custom' },
        ],
      },
    }),
    subject: {
      type: 'Text',
      label: i18n.t('subject'),
      validators: [{ type: 'isRequired' }],
      conditions: [{ type: 'isTemplate', shouldHideField: true }],
    },
    is_html: {
      labelText: i18n.t('use-html-editor'),
      type: 'Boolean',
      conditions: [{ type: 'isTemplate', shouldHideField: true }],
    },
    body: {
      label: i18n.t('body'),
      type: 'TextArea',
      conditions: [
        { type: 'isTemplate', shouldHideField: true },
        { type: 'isHtmlEditorChecked', shouldHideField: true },
      ],
      validators: [{ type: 'isRequired' }],
    },
    html: {
      label: i18n.t('body'),
      type: 'Tiptap',
      conditions: [
        { type: 'isTemplate', shouldHideField: true },
        { type: 'isHtmlEditorUnchecked', shouldHideField: true },
      ],
      validators: [{ type: 'isRequired' }],
    },
    letter_id: {
      type: 'Select',
      selectProps: {
        placeholder: i18n.t('choose-letter'),
        ariaLabel: i18n.t('choose-letter'),
        isFullWidth: true,
      },
      options: transformLetters(letters),
      conditions: [{ type: 'isCustomAdhocLetter', shouldHideField: true }],
    },
    dynamicVariables: {
      type: 'dynamicVariables',
      isDecoration: true,
      title: i18n.t('dynamic-variables-title'),
      buttonText: i18n.t('dynamic-variables'),
      conditions: [{ type: 'isTemplate', shouldHideField: true }],
    },
  };
};
